import { useEffect, useState } from "react";
import { fetchStores } from "@/lib/api";
import { ExternalLink } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Link } from "react-router-dom";
import StoreLogo from "@/components/StoreLogo";

export default function Stores() {
  const [stores, setStores] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    fetchStores().then(setStores);
  }, []);

  const filtered = stores.filter((s) =>
    s.name.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-10" data-testid="stores-page">
      <section className="border-b-2 border-black pb-6 mb-8">
        <div className="text-[10px] tracking-[0.3em] text-[#5c5c5c] mb-2">
          THE DIRECTORY
        </div>
        <h1 className="serif text-5xl md:text-6xl leading-tight tracking-tight">
          Every store in the paper.
        </h1>
        <div className="mt-4 max-w-md">
          <Input
            placeholder="Find a store..."
            value={q}
            onChange={(e) => setQ(e.target.value)}
            data-testid="store-search"
            className="rounded-none border-2 border-black bg-white h-11 mono focus-visible:ring-0 focus-visible:border-[#D34836]"
          />
        </div>
      </section>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {filtered.map((s) => (
          <div
            key={s.name}
            data-testid={`store-${s.name.toLowerCase().replace(/\s+/g, "-")}`}
            className="border-2 border-[#2d2a32] bg-white p-5 hard-shadow-sm hover:hard-shadow flex items-center justify-between group rounded-xl gap-3"
          >
            <div className="flex items-center gap-3 min-w-0">
              <StoreLogo store={s.name} storeUrl={s.url} size={48} />
              <div className="min-w-0">
                <div className="serif text-2xl leading-none tracking-tight truncate">
                  {s.name}
                </div>
                <div className="mono text-[10px] tracking-[0.25em] text-[#5c5c5c] mt-1">
                  {s.count} DEAL{s.count !== 1 ? "S" : ""} · US
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <Link
                to={`/store/${s.name.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'')}`}
                className="text-[10px] tracking-[0.2em] border-2 border-[#2d2a32] px-2 py-1 hover:bg-[#2d2a32] hover:text-white rounded-full"
              >
                VIEW
              </Link>
              {s.url && (
                <a
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border-2 border-[#2d2a32] w-9 h-9 flex items-center justify-center hover:bg-[#ff6b6b] hover:text-white hover:border-[#ff6b6b] rounded-full"
                >
                  <ExternalLink className="w-3.5 h-3.5" />
                </a>
              )}
            </div>
          </div>
        ))}
      </div>

      {filtered.length === 0 && (
        <div className="border-2 border-dashed border-black p-10 bg-white text-center">
          <p className="serif text-3xl">No stores match that name.</p>
        </div>
      )}
    </div>
  );
}
